import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import BootstrapTooltip from "../../partials/content/BootstrapTooltip";
function CustomDataTableBasic({
  data = [],
  columns = [
    {
      header: "",
      field: "",
      body: (rowData) => null,
      sortable: false,
      width: "",
    },
  ],
  onRefreshData = function() {},
  onSelectedData = function() {},
}) {
  return (
    <div className="card datatable-responsive">
      <DataTable
        id="datatablebasic"
        value={data}
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={10}
        selectionMode="single"
        onSelectionChange={(e) => onSelectedData(e.value, e.originalEvent)}
        rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 500, 1000, 5000, 10000]}
        paginatorLeft={
          <BootstrapTooltip title="Refresh Data">
            <Button
              type="button"
              icon="pi pi-refresh"
              className="p-button-text"
              onClick={() => {
                onRefreshData();
              }}
            />
          </BootstrapTooltip>
        }
        paginatorRight={
          <Button type="button" icon="pi pi-cloud" className="p-button-text" />
        }
        className="p-datatable-sm p-datatable-striped p-datatable-responsive"
        emptyMessage="You have no data at this time"
      >
        {columns.map((column, index) => (
          <Column
            key={index}
            header={column.header}
            field={column.field}
            body={column.body}
            sortable={column.sortable}
            style={{
              width: `${column.width}`,
            }}
          />
        ))}
      </DataTable>
    </div>
  );
}

export default CustomDataTableBasic;
